// Define the MutationObserver callback function
const observerCallback = (mutationsList: MutationRecord[], observer: MutationObserver) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      const container = mutation.target as HTMLElement;
      const pages = container.querySelectorAll('span');
      if (pages.length > 6) {
        container.classList.add('is-mini');
        container.classList.remove('is-super-mini');
      }
      
      if (pages.length > 8) {
        container.classList.remove('is-mini');
        container.classList.add('is-super-mini');
      }
    }
  }
};

// Select all containers with the attribute data-pagination-container
const containers = document.querySelectorAll<HTMLElement>('[data-pagination-container]');

// Create a new MutationObserver instance for each container
containers.forEach(container => {
  const observer = new MutationObserver(observerCallback);
  const observerConfig = { childList: true };

  setTimeout(() => {
    observer.observe(container, observerConfig);
  }, 100);
});
